import React from 'react'

const AccountBody = ({ item }) => {
    const { Sno, member, pkg, cDate, cAmt, rAmt, bAmt, rDate, invoice, rNo, remarks } = item;

    return (
        <tbody>
            <tr className="border-b hover:bg-gray-100 animation">
                <td className="table_body border-r">
                    {Sno}
                </td>
                <td className="table_body border-r">
                    {member}
                </td>
                <td className="table_body border-r">
                    {pkg}
                </td>
                <td className="table_body border-r">
                    {cDate}
                </td>
                <td className="table_body border-r">
                    {cAmt}
                </td>
                <td className="table_body border-r">
                    {rAmt}
                </td>
                <td className="table_body border-r">
                    {bAmt}
                </td>
                <td className="table_body border-r">
                    {rDate}
                </td>
                <td className="table_body border-r">
                    {invoice}
                </td>
                <td className="table_body border-r">
                    {rNo}
                </td>
                <td className="table_body border-r">
                    {remarks}
                </td>
            </tr>
        </tbody>
    )
}

export default AccountBody;